export const rawDateFormat: string = "YYYY-MM-DD";

export const yearMonthDay: string = "YYYY.MM.DD";
export const dayMonthYear: string = "DD.MM.YYYY";
